"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreferredTranslation = exports.getPreferredLanguage = exports.getNavigatorLanguages = exports.mergeLanguagePreference = void 0;
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const includes_1 = __importDefault(require("lodash/includes"));
const find_1 = __importDefault(require("lodash/find"));
const map_1 = __importDefault(require("lodash/map"));
const mergeLanguagePreference_1 = __importDefault(require("./mergeLanguagePreference"));
exports.mergeLanguagePreference = mergeLanguagePreference_1.default;
/**
 * @returns {string[]}
 */
const getNavigatorLanguages = () => {
    const languages = [];
    if (typeof navigator !== 'undefined') {
        if (navigator.languages) {
            for (let i = 0; i < navigator.languages.length; i += 1) {
                languages.push(navigator.languages[i]);
            }
        }
        if ('userLanguage' in navigator &&
            navigator.userLanguage &&
            typeof navigator.userLanguage === 'string') {
            languages.push(navigator.userLanguage);
        }
        if (navigator.language) {
            languages.push(navigator.language);
        }
    }
    return languages.map((language) => language.substring(0, 2));
};
exports.getNavigatorLanguages = getNavigatorLanguages;
/**
 * @param {string[]} languagePreference
 * @param {string[]} availableLanguages
 * @param {string | undefined} defaultLanguage
 * @returns {string | undefined}
 */
const getPreferredLanguage = (languagePreference, availableLanguages, defaultLanguage = undefined) => {
    if ((0, isEmpty_1.default)(languagePreference)) {
        return defaultLanguage;
    }
    const n = languagePreference.length;
    for (let i = 0; i < n; i += 1) {
        const language = languagePreference[i];
        if ((0, includes_1.default)(availableLanguages, language)) {
            return language;
        }
    }
    return defaultLanguage;
};
exports.getPreferredLanguage = getPreferredLanguage;
/**
 * @template {{ language: string }} T
 * @param {string[]} languagePreference
 * @param {T[]} availableTranslations
 * @param {string | undefined} [defaultLanguage=undefined]
 * @returns {T | undefined}
 */
const getPreferredTranslation = (languagePreference, availableTranslations, defaultLanguage = undefined) => {
    const language = (0, exports.getPreferredLanguage)(languagePreference, (0, map_1.default)(availableTranslations, 'language'), defaultLanguage);
    if (!language) {
        return undefined;
    }
    const matchedTranslation = (0, find_1.default)(availableTranslations, (translation) => {
        return translation.language === language;
    });
    if (matchedTranslation) {
        return matchedTranslation;
    }
    return undefined;
};
exports.getPreferredTranslation = getPreferredTranslation;
//# sourceMappingURL=index.js.map